import { PolicyPodetailReq, PolicyPodetailResp } from 'app/bff/models/policy/policyPodetail';
import { AaOtpSendcodeReq, AaOtpSendcodeResp } from 'app/bff/models/aa/aaOtpSendcode';
import { AaOtpVerifyReq } from 'app/bff/models/aa/aaOtpVerify';
import { PolicyAmendTravelperiodReq } from 'app/bff/models/policy/policyAmendTravelperiod';
import { PaymentCreditAuthReq } from 'app/bff/models/payment/paymentCreditAuth';
import { ProcessStepCodesEnum } from 'app/features/Service/QueryPolicy/Modify/types';
import { FormValues as PolicyInfoFormValues } from 'app/features/Service/QueryPolicy/Modify/PolicyInfo/types';
import { ModifyState, ModifyActions, SERVICE_QUERY_POLICY_MODIFY__FETCH_POLICY_DETAIL, SERVICE_QUERY_POLICY_MODIFY__FETCH_POLICY_DETAIL_DONE, SERVICE_QUERY_POLICY_MODIFY__SET_ACCESSIBLE_STEP, SERVICE_QUERY_POLICY_MODIFY__SAVE_POLICY_INFO_PAGE_DATA, SERVICE_QUERY_POLICY_MODIFY__SEND_OTP, SERVICE_QUERY_POLICY_MODIFY__SEND_OTP_DONE, SERVICE_QUERY_POLICY_MODIFY__RESEND_OTP, SERVICE_QUERY_POLICY_MODIFY__RESEND_OTP_DONE, SERVICE_QUERY_POLICY_MODIFY__AUTH_OTP, SERVICE_QUERY_POLICY_MODIFY__EXECUTE_CREDIT_CARD_PAYMENT, SERVICE_QUERY_POLICY_MODIFY__MODIFY_POLICY_PERIOD, SERVICE_QUERY_POLICY_MODIFY__UPDATE_CACHE, SERVICE_QUERY_POLICY_MODIFY__RESET_CACHE, SERVICE_QUERY_POLICY_MODIFY__SAVE_MODIFY_REQ, SERVICE_QUERY_POLICY_MODIFY__SAVE_TRANS_ID } from './types';

/**
 * @description 取得保單明細 (Action)
 * @param args 請求所需的參數
 */
export const fetchPolicyDetailAction = (args: PolicyPodetailReq): ModifyActions => ({
  type: SERVICE_QUERY_POLICY_MODIFY__FETCH_POLICY_DETAIL,
  payload: { args }
});

/**
 * @description 取得保單明細 完成 (Action)
 * @param response 請求回傳的 Response
 */
export const fetchPolicyDetailDoneAction = (response: PolicyPodetailResp['policyTravel']): ModifyActions => ({
  type: SERVICE_QUERY_POLICY_MODIFY__FETCH_POLICY_DETAIL_DONE,
  payload: { response }
});

/**
 * @description 設置可訪問步驟 (Action)
 * @param step 當前步驟
 */
export const setAccessibleStepAction = (step: ProcessStepCodesEnum): ModifyActions => ({
  type: SERVICE_QUERY_POLICY_MODIFY__SET_ACCESSIBLE_STEP,
  payload: { step }
});

/**
 * @description 緩存「修改保期」(Step-1) 資料 (Action)
 * @param data 頁面資料
 */
export const savePolicyInfoPageInfoAction = (data: PolicyInfoFormValues): ModifyActions => ({
  type: SERVICE_QUERY_POLICY_MODIFY__SAVE_POLICY_INFO_PAGE_DATA,
  payload: { data }
});

/**
 * @description 發送 OTP 驗證碼 (Action)
 * @param args 請求所需的參數
 */
export const sendOTPAction = (args: AaOtpSendcodeReq): ModifyActions => ({
  type: SERVICE_QUERY_POLICY_MODIFY__SEND_OTP,
  payload: { args }
});

/**
 * @description 發送 OTP 驗證碼 完成 (Action)
 * @param response 請求回傳的 Response
 */
export const sendOTPDoneAction = (response: AaOtpSendcodeResp): ModifyActions => ({
  type: SERVICE_QUERY_POLICY_MODIFY__SEND_OTP_DONE,
  payload: { response }
});

/**
 * @description 重新發送 OTP 驗證碼 (Action)
 * @param args 請求所需的參數
 */
export const resendOTPAction = (args: AaOtpSendcodeReq): ModifyActions => ({
  type: SERVICE_QUERY_POLICY_MODIFY__RESEND_OTP,
  payload: { args }
});

/**
 * @description 重新發送 OTP 驗證碼 完成 (Action)
 * @param response 請求回傳的 Response
 */
export const resendOTPDoneAction = (response: AaOtpSendcodeResp): ModifyActions => ({
  type: SERVICE_QUERY_POLICY_MODIFY__RESEND_OTP_DONE,
  payload: { response }
});

/**
 * @description 驗證 OTP 驗證碼 (Action)
 * @param authOTPArgs 驗證 OTP 請求所需的參數
 * @param modifyPolicyPeriodArgs 保期修改請求所需的參數
 */
export const authOTPAction = (authOTPArgs: AaOtpVerifyReq, modifyPolicyPeriodArgs: PolicyAmendTravelperiodReq): ModifyActions => ({
  type: SERVICE_QUERY_POLICY_MODIFY__AUTH_OTP,
  payload: { authOTPArgs, modifyPolicyPeriodArgs }
});

/**
 * @description 執行信用卡繳費 (Action)
 * @param args 請求所需的參數
 * @param modifyPolicyPeriodArgs 保期修改請求所需的參數
 */
export const executeCreditCardPaymentAction = (args: PaymentCreditAuthReq, modifyPolicyPeriodArgs: PolicyAmendTravelperiodReq): ModifyActions => ({
  type: SERVICE_QUERY_POLICY_MODIFY__EXECUTE_CREDIT_CARD_PAYMENT,
  payload: { args, modifyPolicyPeriodArgs }
});

/**
 * @description 執行保期修改
 * @param args 請求所需的參數
 */
export const modifyPolicyPeriodAction = (args: PolicyAmendTravelperiodReq): ModifyActions => ({
  type: SERVICE_QUERY_POLICY_MODIFY__MODIFY_POLICY_PERIOD,
  payload: { args }
});

/**
 * @description 更新資料緩存 (Action)
 * @param cache 緩存資料
 */
export const updateCacheAction = (cache: ModifyState): ModifyActions => ({
  type: SERVICE_QUERY_POLICY_MODIFY__UPDATE_CACHE,
  payload: { cache }
});

/**
 * @description 重置資料緩存 (Action)
 */
export const resetCacheAction = (): ModifyActions => ({
  type: SERVICE_QUERY_POLICY_MODIFY__RESET_CACHE
});

/**
 * @description 緩存 IR#017 上行電文 (Action)
 */
export const saveModifyAction = (args: PolicyAmendTravelperiodReq): ModifyActions => ({
  type: SERVICE_QUERY_POLICY_MODIFY__SAVE_MODIFY_REQ,
  payload: { args }
});

/**
 * @description 緩存交易序號 (noticeNo/orderId) (Action)
 */
export const saveTransIdAction = (transId: string): ModifyActions => ({
  type: SERVICE_QUERY_POLICY_MODIFY__SAVE_TRANS_ID,
  payload: { transId }
});
